module.exports = __webpack_public_path__ + "static/media/Sarah_Stein_DDS.7cae99fd.png";